import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/rdt/';

class RdtGerenciador {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    gerar(idCliente, idUsuario, ano, mes) {
        return axios.post(API_URL + 'gerar?idCliente='+idCliente+'&idUsuario='+idUsuario+'&ano='+ano+'&mes='+mes, null, {headers: this.headers});
    }

    editar(idRdt, idUsuario, protocolo, observacao, notas) {
        return axios.post(API_URL + 'editarRdt?idRdt='+idRdt+'&idUsuario='+idUsuario+'&protocolo='+protocolo+'&observacao='+observacao, notas, {headers: this.headers});
    }

    cancelar(cancelamento) {
        return axios.post(API_URL + 'cancelar', cancelamento, {headers: this.headers});
    }

    findAllPorPeriodo(idCliente, idContribuinte, filtro, dataInicio, dataFim) {
        let filtros = '';
        if(idContribuinte != null){
            filtros += '&idContribuinte='+idContribuinte;
        }
        if(filtro != null && filtro != ''){
            filtros += '&filtroContribuinte='+filtro;
        }
        if(dataInicio != null && dataFim != null){
            filtros += '&dataIni='+dataInicio+'&dataFim='+dataFim;
        }
        
        return axios.get(API_URL + 'findAllPorPeriodo?idCliente='+idCliente+filtros, { headers: this.headers });
        
    }

    findAllDeclaracoes(idRdt) {
        return axios.get(API_URL + 'findAllDeclaracoes?idRdt=' + idRdt,
            { headers: this.headers }).then(response => (this.data = response.data));
    }

    findAllNotasRdt(idRdt) {
        return axios.get(API_URL + 'findAllNotasRdt?idRdt=' + idRdt,
            { headers: this.headers }).then(response => (this.data = response.data));
    }

    findAllNotasProtocolo(idProtocolo) {
        return axios.get(API_URL + 'findAllNotasProtocolo?idProtocolo=' + idProtocolo,
            { headers: this.headers }).then(response => (this.data = response.data));
    }

    buscarVencimentoAtual(idRdt) {
        return axios.get(API_URL + 'buscarVencimentoAtual?idRdt=' + idRdt, { headers: this.headers });
    }

    buscarProtocoloEdicao(idRdt) {
        return axios.get(API_URL + 'buscarProtocoloEdicao?idRdt=' + idRdt, { headers: this.headers });
    }

}

export default new RdtGerenciador();